module.exports = __webpack_public_path__ + "media/images/ep-trademark-24b2c2373db4e889df41e1fe2f74c3b2.png";